import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { verifyToken } from '../Functions/verifyToken';
import { useAuth } from './AuthContext';

import '../Styles/styles.css';

const ProtectedRoute = ({ children }) => {
    const [isValid, setIsValid] = useState(null);
    const { logout, token } = useAuth();

    useEffect(() => {
        verifyToken(token).then(setIsValid);
    }, []);

    if (isValid === null) {
        return (
            <div className="loading">
                <div className="spinner"></div>
                <h1>Loading... 😊</h1>
            </div>
        );
    }

    if (isValid === false) {
        logout();
        return <Navigate to="/login" replace />;
    }

    return children;
};

export default ProtectedRoute;
